import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { ExternalLink, Icon, IconSocialMediaInstagram, IconSocialMediaX } from '../../components';
import classNames from 'classnames';

import css from './ContactPage.module.css';

const contactItem = (iconName, value, link) =>
  link ? (
    <ExternalLink
      className={classNames(css.contactDetailsItem, css.contactDetailsItemLink)}
      href={link}
    >
      <Icon name={iconName} size={24} className={css.contactDetailsItemIcon} />
      <div className={css.contactDetailsItemText}>{value}</div>
    </ExternalLink>
  ) : (
    <div className={css.contactDetailsItem}>
      <Icon name={iconName} size={24} className={css.contactDetailsItemIcon} />
      <div className={css.contactDetailsItemText}>{value}</div>
    </div>
  );

const socialItem = (icon, link, label) =>
  link ? (
    <ExternalLink className={css.contactDetailsSocialItem} href={link} aria-label={label}>
      <div className={css.contactDetailsSocialItemIcon}>{icon}</div>
    </ExternalLink>
  ) : (
    <div className={css.contactDetailsSocialItem}>
      <div className={css.contactDetailsSocialItemIcon}>{icon}</div>
    </div>
  );

const ContactDetails = () => {
  const intl = useIntl();
  return (
    <div className={css.contactDetails}>
      <h2 className={css.contactDetailsTitle}>
        <FormattedMessage id="ContactPage.contactDetails" />
      </h2>
      <p className={css.contactDetailsText}>
        <FormattedMessage id="ContactPage.contactDetailsText" />
      </p>
      <div className={css.contactDetailsItems}>
        {contactItem('phone', '+1438 921 4078', 'tel:+14389214078')}
        {contactItem('mail', 'team@attractr.live', 'mailto:team@attractr.live')}
        {contactItem('location', '4060 boul Saint-Laurent Suite 703 Montreal, Quebec, Canada')}
      </div>
      <div className={css.contactDetailsSocialItems}>
        {socialItem(
          <IconSocialMediaX rootClassName={css.socialIcon} />,
          'https://x.com/attractr',
          intl.formatMessage({ id: 'ContactPage.socialX' })
        )}
        {socialItem(
          <IconSocialMediaInstagram rootClassName={css.socialIcon} />,
          'https://www.instagram.com/attractr',
          intl.formatMessage({ id: 'ContactPage.socialInstagram' })
        )}
        {socialItem(
          <Icon name="comment" size={14} className={css.socialLucideIcon} />,
          `${process.env.REACT_APP_CANONICAL_ROOT_URL}/community`,
          intl.formatMessage({ id: 'ContactPage.socialCommunity' })
        )}
      </div>
    </div>
  );
};

export default ContactDetails;
